import React, { useEffect, useState } from 'react';
import ReuploadForm from './ReuploadForm';
import './Login.css';

export default function VendorReuploadDashboard({ vendorData, setVendorData, vendorFiles, setVendorFiles, api }) {
  const [userLogo, setUserLogo] = useState('Main.png'); // Default logo
  const [companyLogo, setCompanyLogo] = useState('Main.png'); // Company-specific logo

  useEffect(() => {
    // Fetch company logo based on vendor's active company
    (async () => {
      try {
        const res = await api.get('/api/active-company/');
        if (res.data.company) {
          // Use the logo returned from backend (already mapped correctly)
          const logo = res.data.company.logo || 'Main.png';
          setCompanyLogo(logo);
          console.log(`✅ Reupload Dashboard loaded with company: ${res.data.company.name}, logo: ${logo}`);
        }
      } catch (err) {
        console.error("Error fetching active company:", err);
        setCompanyLogo('Main.png'); // Default on error
      }
    })();

    // Also fetch user logo (for backward compatibility)
    (async () => {
      try {
        const res = await api.get('/api/user-logo/');
        const logoName = res.data?.logo || 'Main.png';
        setUserLogo(logoName);
      } catch {
        setUserLogo('Main.png'); // Default on error
      }
    })();

    // Check session validity periodically (every 30 seconds)
    const sessionCheckInterval = setInterval(async () => {
      try {
        const sessionRes = await api.get('/api/check-session/');
        if (!sessionRes.data?.valid) {
          // Session invalid - redirect to login
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          localStorage.removeItem('session_id');
          window.location.href = '/';
        }
      } catch (err) {
        if (err.response?.status === 401) {
          // Session expired - redirect to login
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          localStorage.removeItem('session_id');
          window.location.href = '/';
        }
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(sessionCheckInterval);
  }, [api]);

  const handleLogout = async () => {
    try {
      await api.post('/api/logout/');
    } catch (err) {
      // Logout API failed
    }
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('session_id');
    localStorage.removeItem('vendor_login_type'); // Clear login type on logout
    window.location.href = '/';
  };

  return (
    <div className="login-container" style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Logo at top left - Company-specific logo */}
      <img draggable={false}
        src={process.env.PUBLIC_URL + '/' + companyLogo}
        alt="Company Logo"
        className="logo"
        style={{ position: 'absolute', top: '-14px', left: '-260px', width: '200px', zIndex: 1000 }}
        onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/Main.png'; }}
      />

      {/* Header with white background */}
      <header style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '90%',
        maxWidth: '1051px',
        padding: '16px 24px',
        marginTop: '-10px',
        marginBottom: '-7px',
        marginLeft: 'auto',
        marginRight: 'auto',
        background: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        border: '1px solid #e5e7eb',
        position: 'relative',
        zIndex: 1
      }}>
        <h1 style={{ color: '#333', fontSize: 20, margin: 0, fontWeight: 600 }}>Vendor Portal - Re-Upload Documents</h1>
        <nav style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <button
            onClick={handleLogout}
            style={{
              padding: '8px 16px',
              borderRadius: 8,
              border: '1px solid #dc2626',
              background: '#dc2626',
              color: '#fff',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 500,
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.background = '#b91c1c'}
            onMouseLeave={(e) => e.target.style.background = '#dc2626'}
          >Logout</button>
        </nav>
      </header>

      <main style={{
        maxWidth: 1200,
        width: '92%',
        margin: '10px auto 24px',
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
        padding: '12px 0'
      }}>
        <div style={{ padding: 0 }}>
          <ReuploadForm api={api} onSuccess={() => {
            // After successful reupload, clear login type and redirect to login
            localStorage.removeItem('vendor_login_type');
            handleLogout();
          }} />
        </div>
      </main>
    </div>
  );
}

